module.exports = __webpack_public_path__ + "static/calloutAuto-ef471037b20d6cddf1ec18c4e02d6575.jpg";